import { movieApi } from '../../redux/services/movieApi'
import { LoaderTopMovie } from '../../ui/LoaderTopMovie/LoaderTopMovie'
import { TopMovie } from '../TopMovie/TopMovie'
import './TopMovies.scss'

export const TopMovies = () => {
    const { data: topMovies, isLoading, error, refetch } = movieApi.useGetTopMoviesQuery(10)

    return (
        <section className='top-movies'>
            <div className="container top-movies__container">
                <h2 className='title-min top-movies__title'>Топ 10 фильмов</h2>
                <div className="top-movies__wrap">
                    {isLoading && <LoaderTopMovie />}
                    {error &&
                        <div>
                            <h2 style={{ marginBottom: "10px" }}> Произошла ошибка</h2> <button className='btn btn-dark' onClick={() => refetch()}>Обновить список</button>
                        </div>}
                    <ul className='top-movies__list'>
                        {topMovies && topMovies.map((topMovie, index) =>
                            <li className='top-movies__item' key={topMovie.id}>
                                <TopMovie index={index} topMovie={topMovie} />
                            </li>

                        )}
                    </ul>
                </div>

            </div>
        </section>
    )
}